import {Component, input, output} from '@angular/core';
import {Dialog} from "primeng/dialog";
import {Button} from "primeng/button";

@Component({
    selector: 'app-confirm-dialog',
    imports: [
        Dialog,
        Button,
    ],
    templateUrl: './confirm-dialog.html',
    styleUrl: './confirm-dialog.css'
})
export class ConfirmDialog {

    // Entradas
    visible = input(false);
    closable = input(true);
    width = input('auto');
    height = input('auto');
    headerTitle = input('Confirmação');
    message = input('Deseja realmente realizar esta operação?');
    cancelLabel = input('Cancelar');
    confirmLabel = input('Confirmar');

    // Saídas
    cancel = output<void>();
    confirm = output<void>();
    visibleChange = output<boolean>();

    onClickCancel() {
        this.cancel.emit();
        this.updateVisible(false);
    }

    onClickConfirm() {
        this.confirm.emit();
        this.updateVisible(false);
    }

    private updateVisible(val: boolean) {
        this.visibleChange.emit(val);
    }
}
